import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <p>© 2025 The Sapienta Group, LLC. All rights reserved. Your use of this site signifies that you accept our <Link to="/terms-conditions" className={styles.footerLink}>terms & conditions of use.</Link></p>
      <div className={styles.footerLinks}>
        <Link to="/privacy-policy" className={styles.footerLink}>Privacy Policy</Link>
        <Link to="/disclaimer" className={styles.footerLink}>Disclaimer</Link>
        <Link to="/cookie-policy" className={styles.footerLink}>Cookie Policy</Link>
      </div>
    </footer>
  );
}

export default Footer; 